import { CheckCircleOutlined } from '@ant-design/icons';
import { Card, Tabs } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import DateTime from '../../components/Formatter/DateTime';
import { ParamsContext } from '../Context/ParamsContext';

const { TabPane } = Tabs;

const PassportProject = ({ project }) => {
  const [selected, setSelected] = useState({
    tab: 'Tap History',
    key: 'tap',
  });

  const tabList = [
    {
      tab: 'Tap History',
      key: 'tap',
    },
    {
      key: 'passport',
      tab: 'Personel',
    }
  ];

  const contentList = {
    tap: <ProjectTap project={project} />,
    passport: <ProjectPassport project={project}/>,
  }
  return (
    <>
      <Tabs defaultActiveKey={selected.key} onChange={(key) => setSelected(tabList.find(el => el.key === key))}>
        {tabList.map((item, key) => {
          return (
            <TabPane tab={item.tab} key={item.key}>
              {contentList[selected.key]}
            </TabPane>
          );
        })}
      </Tabs>
    </>
  );
}

export default PassportProject;

const ProjectPassport = ({ project }) => {
  const columns = [
    {
      title: "Nama",
      key: 'name',
      render: record => (
        <>
          {record.name} ({record.gender}) {record.rfid_number ? <CheckCircleOutlined className="gx-ml-1 gx-text-info" /> : null}
          <div className="gx-text-muted">{record.email}</div>
        </>
      ),
      filter: true
    },
    {
      title: "Perusahaan",
      dataIndex: "vendor",
      key: 'vendor',
      render: vendor => vendor.name,
    },
  ];
  const [loading, setLoading] = useState(true);
  const [passport, setPassport] = useState([]);
  const [total, setTotal] = useState(null);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchPassport();
  }, [params]);

  const fetchPassport = () => {
    setLoading(true);
    const url = `/passport/list`;
    axios.get(url, {params: {...params, project: project.id}}).then(resp => {
      setPassport(resp.data.passports);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {
      console.error(err);
    });
  }
  return (
    <Table
      columns={columns}
      dataSource={passport}
      loading={loading}
      total={total}
      showSorterTooltip
    />
  );
}

const ProjectTap = ({project}) => {
  const columns = [
    {
      title: "Tanggal",
      key:'stored_at',
      render: record => <DateTime value={record.stored_at}/>,
      sorter: true,
    },
    {
      title: "Nama",
      key: 'name',
      render: record => record.passport.name,
      filter: true
    },
    {
      title: "Jenis",
      dataIndex: "type",
      key: 'type',
      render: type => type.label,
    },
  ];
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(null);

  const params = useContext(ParamsContext);

  useEffect(() => {
    fetchTap();
  }, [params]);

  const fetchTap = () => {
    setLoading(true);
    const url = `/tap/list`;
    axios.get(url, {params: {...params, project: project.id}}).then(resp => {
      setData(resp.data.taps);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {
      console.error(err);
    });
  }
  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      total={total}
      showSorterTooltips
    />
  );
}